import { Pipe, PipeTransform } from '@angular/core';
import {
  KYMW7002PricePatternValue,
  PricePatternList,
} from '../kymw7002.model';

@Pipe({
  name: 'pricePattern'
})
export class PricePatternPipe implements PipeTransform {

  transform(value: KYMW7002PricePatternValue): string {
    let label = String(value);

    for (const pricePattern of PricePatternList) {
      if (pricePattern.value === value) {
        label = pricePattern.label;
      }
    }

    return label;
  }

}
